<zef-form
  [state]="state"
  (submitEvent)="submit.emit()">

  <zef-form-field class="__form-field">
    <mat-form-field color="accent">

      <mat-label>{{ translations?.purgeCacheForm.purgeCacheLabel }}</mat-label>

      <textarea
        class="__textarea"
        rows="12"
        [ngrxEnableFocusTracking]="true"
        [ngrxFormControlState]="state?.controls.urls"
        [placeholder]="translations?.purgeCacheForm.purgeCachePlaceholder"
      matInput></textarea>

      <mat-hint>{{ translations?.purgeCacheForm.purgeCacheHint }}</mat-hint>

      @if (state?.controls.urls.errors['validateUrls']?.actual) {
        <mat-error>
          {{ formErrorTranslations[state?.controls.urls.errors['validateUrls']?.message] }}
        </mat-error>
      }

    </mat-form-field>

  </zef-form-field>

  <ng-content></ng-content>

</zef-form>
